import { Injectable } from '@angular/core';
import { UserResponse } from '../../../api-gen/gen/models/user-response';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  constructor() {}

  public showFeatures(
    member: UserResponse | undefined,
    skip: boolean = false,
    forFaceMatch = false,
  ): boolean {
    if (!member) {
      return false;
    }

    if (member?.email.includes('kinguin')) {
      return false;
    }

    if (member?.email.includes('upgate')) {
      return false;
    }

    // if (
    //   member?.id == '9ojDr' ||
    //   member?.id == '9MELx' ||
    //   member?.id == 'JzOBa'
    // ) {
    //   return false;
    // }

    if (skip) {
      return true;
    }

    if (environment.site === 'ECAF') {
      return true;
    }

    if (member.hasPurchase) {
      return true;
    }

    // if (member.hasPurchase && this.memberIsOlderThan30Days(member)) {
    //   return true;
    // }
    //
    // if (forFaceMatch) {
    //   return false;
    // }
    //
    // if (
    //   new Date(member.created).getTime() >
    //   Date.now() - 30 * 24 * 60 * 60 * 1000
    // ) {
    //   return false;
    // }

    return true;
  }

  private memberIsOlderThan30Days(member: UserResponse): boolean {
    return (
      new Date(member.created).getTime() < Date.now() - 30 * 24 * 60 * 60 * 1000
    );
  }

  isModeratedUser(member: UserResponse | undefined) {
    if (!member) {
      return true;
    }

    if (
      member.id === '9ojDr' ||
      member.id === '9MELx' ||
      member.id === 'JzOBa'
    ) {
      return true;
    }

    return false;
  }

  showTemplate(currentUser: UserResponse | undefined): boolean {
    if (!currentUser) {
      console.log('no current user');
      return false;
    }

    if (this.isModeratedUser(currentUser)) {
      return false;
    }

    // if not older than 30 days
    if (
      new Date(currentUser.created).getTime() >
      Date.now() - 10 * 24 * 60 * 60 * 1000
    ) {
      return false;
    }

    return true;
  }
}
